// @flow
import { GroupsContactsActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    groupContact: {},
    listaGroupsContacts: [],
    loading: false,
    error: false,
    formSubmited: false
};

type GroupsContactsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { groupContact?: {} | null, listaGroupsContacts?: [] | null, loading?: boolean, +value ?: boolean };

const GroupsContacts = (state: State = INIT_STATE, action: GroupsContactsAction): any => {
    // console.log(action);
    switch (action.type) {
        case GroupsContactsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case GroupsContactsActionTypes.GET_GROUPS_CONTACTS: {
                    return {
                        ...state,
                        groupContact: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case GroupsContactsActionTypes.LIST_GROUPS_CONTACTS: {
                    return {
                        ...state,
                        listaGroupsContacts: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case GroupsContactsActionTypes.ADD_GROUPS_CONTACTS: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case GroupsContactsActionTypes.UPDATE_GROUPS_CONTACTS: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case GroupsContactsActionTypes.DELETE_GROUPS_CONTACTS: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case GroupsContactsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case GroupsContactsActionTypes.GET_GROUPS_CONTACTS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        groupContact: {},
                        loading: false,
                    };
                }
                case GroupsContactsActionTypes.LIST_GROUPS_CONTACTS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaGroupsContacts: [],
                        loading: false,
                    };
                }
                case GroupsContactsActionTypes.ADD_GROUPS_CONTACTS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case GroupsContactsActionTypes.UPDATE_GROUPS_CONTACTS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case GroupsContactsActionTypes.DELETE_GROUPS_CONTACTS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case GroupsContactsActionTypes.GET_GROUPS_CONTACTS:
            return { ...state, error: false, loading: true };
        case GroupsContactsActionTypes.LIST_GROUPS_CONTACTS:
            return { ...state, error: false, loading: true };
        case GroupsContactsActionTypes.ADD_GROUPS_CONTACTS:
            return { ...state, error: false, loading: true };
        case GroupsContactsActionTypes.UPDATE_GROUPS_CONTACTS:
            return { ...state, error: false, loading: true };
        case GroupsContactsActionTypes.DELETE_GROUPS_CONTACTS:
            return { ...state, error: false, loading: true };
        case GroupsContactsActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                groupContact: {},
                listaGroupsContacts: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default GroupsContacts;
